import React from "react";
import aboutImage from "../../assets/images/about-project.jpeg";
import fundingAgencyImg from "../../assets/images/p2p.png";
import "./style.scss";


const About = (props) => {
  return (
    <div className="col-6 d-flex justify-content-center flex-column align-items-center mx-auto about-container">
      <img src={aboutImage} className="w-100" alt="about" />
      <p>
        This platform is developed by Smart grid LAB German Jordanian University
        to suit the electricity network of Jordan, considering minimizing the
        network losses by trading with the nearest peer. The term “peers” in the
        energy market indicates the grid-connected parties which could be two or
        more. These parties are available in the grid in two forms, ordinary
        consumers, and prosumers (consumers who have their renewable energy
        resources such as rooftop solar systems). Peer-to-peer (P2P) energy
        trading enables prosumers to actively participate in the electricity
        market and gain incentivized profits. The P2P market is constructed in
        the low voltage network within a microgrid or among neighbor microgrids.
        The energy market has been revolutionized in recent years due to various
        aspects. These aspects include the proliferation of distributed
        renewable energy resources and the increase in the number of prosumers
        in the local electricity network, as well as the development in
        information systems. The local energy market is undergoing several
        developments to accommodate energy participants through various trading
        mechanisms and balance the supply and demand within the microgrid.
        Prosumers who are the agents with renewable energy resources such as
        rooftop solar panels are integrated with the grid and trade their excess
        energy using certain policies that vary from one country to another, for
        example, net-metering and feed-in tariff. An alternative policy is
        needed to adapt to the rapid development in the energy sector worldwide.
        One of the promising trading strategies is Peer-to-peer (P2P) energy
        trading. This platform is designed for you to join and participate in
        the local electricity market in Jordan to buy energy at a low cost and
        start trading your surplus energy with more profits."
      </p>
      <img width={"400"} src={fundingAgencyImg} alt="agency" />

    </div>
  );
};

export default About;
